import React, { useEffect } from 'react';
import Container from '@/components/container';
import { withRouter } from 'react-router-dom';
import './index.less';
import { Button } from '@drip/drip-design';
import env from '@/env';

function NoPowerPage(props: any) {
  const { resCode } = props;

  useEffect(() => {
    if ((window as any).__OSW_ENVIRONMENT__) {
      (window as any).$osw?.onConnected(() => {
        (window as any).$osw?.goApplyAuth();
      });
    }
  });

  if ((window as any).__OSW_ENVIRONMENT__) return null; // 如果是被内嵌的情况，则返回null

  const jumpToNopowerPage = () => {
    // 之前跳转有resCode，产品方案去掉了 https://joyspace.jd.com/pages/fCAcG8rwr1I5DJO0ZsU2
    props.history.push('/system/authSetting');
  };

  return (
    <Container>
      <div className="noPower-wrap">
        <img
          src="https://img10.360buyimg.com/img/jfs/t1/268588/3/19804/42618/67af0d4dF9e2650b8/a6fd45a7671c9d32.png"
          width={120}
          height={120}
        />
        {resCode ? (
          <>
            <div className="noPower-des">对不起，您没有权限使用该功能</div>
            <Button type="primary" onClick={jumpToNopowerPage}>
              立即申请
            </Button>
          </>
        ) : (
          <div className="noPower-des">抱歉！您没有当前页面的查看权限！</div>
        )}
      </div>
    </Container>
  );
}

export default withRouter(NoPowerPage);
